import React, { useState, useEffect, useCallback } from 'react';
import { MotifDropdown } from '../../dropdown/dropdown';
import { MotifIconButton } from '../../button/icon-button/icon-button';
import { ReactComponent as HardwareIcKeyboardArrowDown24px } from '../../../assets/icons/hardware/ic_keyboard_arrow_down_24px.svg';
import PropTypes from 'prop-types';
import { PaginationSelectProvider } from './pagination-select.context';

const defaultIcons = {
  openToggle: <HardwareIcKeyboardArrowDown24px />
};

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {{openToggle: React.ReactNode}} [icons]
 * @prop {{}} [toggleButtonProps]
 */
/**
 * @param {Props} props
 */
const MotifPaginationSelect = ({ children, icons: userIcons = {}, toggleButtonProps = {} }) => {
  const icons = {
    ...defaultIcons,
    ...userIcons
  };
  const [isOpen, setIsOpen] = useState(false);
  const [itemsPerPageValue, setItemsPerPageValue] = useState('');

  const contextSettings = {
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    itemsPerPageValue: itemsPerPageValue,
    setItemsPerPageValue: setItemsPerPageValue
  };

  const handleToggle = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  const setClickOutside = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    setItemsPerPageValue(getItemsPerPageValue());
  });

  const getItemsPerPageValue = () => {
    const childrenValue = itemsPerPageValue.length
      ? itemsPerPageValue
      : children && children.filter(currentItem => currentItem.props.selected)[0].props.children;

    return childrenValue;
  };

  return (
    <PaginationSelectProvider value={contextSettings}>
      <div className="motif-pagination-select-wrapper" data-motif-pagination-select>
        <MotifDropdown
          className="motif-pagination-select"
          open={isOpen}
          placement="bottom-left"
          handleClickOutside={setClickOutside}
          trigger={
            <MotifIconButton
              type="button"
              onClick={handleToggle}
              aria-expanded={isOpen}
              {...toggleButtonProps}
            >
              <span>{itemsPerPageValue}</span>
              {icons.openToggle}
            </MotifIconButton>
          }
        >
          {children}
        </MotifDropdown>
      </div>
    </PaginationSelectProvider>
  );
};

MotifPaginationSelect.propTypes = {
  children: PropTypes.node,
  icons: PropTypes.shape({
    openToggle: PropTypes.node
  }),
  toggleButtonProps: PropTypes.instanceOf(Object)
};

export { MotifPaginationSelect };
